var _style, _polygon, _g, _polygon2, _polygon3, _polygon4, _polygon5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHoloBase(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "HoloBase",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 281 105",
    style: {
      enableBackground: "new 0 0 281 105"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{opacity:0.2;}\n\t.st2{fill:#D64DF2;}\n\t.st3{fill:#663B9E;}\n\t.st4{fill:#944EC6;}\n\t.st5{fill:#7946AF;}\n\t.st6{fill:#884FBA;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.32,
    y1: 88.3386,
    x2: 174.0016,
    y2: -28.8893
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6C2899"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2257,
    style: {
      stopColor: "#6F2A9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4411,
    style: {
      stopColor: "#7630A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6525,
    style: {
      stopColor: "#833BBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#9549D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A455ED"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "249.9,44.1 250.4,15.2 140.5,1 30.3,15.6 30.3,44.5 140.5,59  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M140.5,4l106.9,13.8L247,41.5L140.4,56L33.3,41.8l-0.1-23.6L140.5,4 M140.5,1L30.3,15.6l0.1,28.9L140.5,59 l109.5-14.9l0.5-28.9L140.5,1L140.5,1z"
  })))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    className: "st3",
    points: "30.3,15.6 0.4,44.1 0.4,81.9 30.3,44.6 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2_1_",
    className: "st4",
    points: "250.3,15.2 275.9,44.2 280.9,81.9 249.8,44.1 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    className: "st5",
    points: "30.4,44.3 140.5,59 140.3,104.7 0.4,81.9 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3_1_",
    className: "st6",
    points: "249.9,44.2 140.5,59 140,104.7 280.9,82 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoloBase);
export default __webpack_public_path__ + "static/media/holo-base.dd6f872aa9d35b78b0ee435b37be3d77.svg";
export { ForwardRef as ReactComponent };